export default __webpack_public_path__ + "static/media/brussels_roasted_parmesan.07cb1f87.png";